exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1264px) {\n.big-text[data-v-586d3fa3] {\n    font-size: 1.2rem !important;\n    line-height: 1.7;\n}\n}", ""]);

// exports
